import { ArrowUpTrayIcon } from '@heroicons/react/24/outline';
import React, { useRef, useState } from 'react';

interface FileSelectorProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  buttonLabel?: string;
}

const FileSelector: React.FC<FileSelectorProps> = ({
  label,
  buttonLabel = 'Choisir un fichier',
  className,
  onChange,
  accept,
  ...props
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [fileName, setFileName] = useState<string>('');

  const handleButtonClick = () => {
    inputRef.current?.click();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setFileName(file.name);
    } else {
      setFileName('');
    }
    if (onChange) {
      onChange(event);
    }
  };

  // Default safe image types - only common formats for better compatibility

  return (
    <div className={`flex flex-col gap-1 ${className || ''}`}>
      {label && <span className="text-sm font-medium text-gray-700">{label}</span>}
      <div className="flex items-center gap-3">
        <input
          {...props}
          accept={accept}
          ref={inputRef}
          type="file"
          className="hidden"
          onChange={handleFileChange}
        />
        <button
          type="button"
          onClick={handleButtonClick}
          disabled={props.disabled}
          className={`
            flex items-center gap-2 rounded-full px-4 py-2.5 text-sm font-semibold transition-all duration-200
            ${props.disabled
    ? 'cursor-not-allowed border border-gray-200 bg-gray-100 text-gray-400'
    : 'bg-rgpd-blue text-white shadow-sm hover:bg-rgpd-blue-dark hover:shadow focus:ring-2 focus:ring-rgpd-blue focus:ring-offset-2 focus:outline-none'}
          `}
        >
          <ArrowUpTrayIcon className="h-4 w-4" />
          {buttonLabel}
        </button>
        <span className={`max-w-xs truncate text-sm ${props.disabled ? 'text-gray-300' : 'text-gray-500'}`}>
          {fileName || 'Aucun fichier sélectionné'}
        </span>
      </div>
    </div>
  );
};

export default FileSelector;
